export const ATTACHMENT_ICS = 1;